import QueryString from 'qs';
import { useNavigate } from 'react-router-dom';
import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { IReqTmarkRightsPage, TmarkRightsDetail } from 'src/types/api/trademarkRightsApiTypes';
import StatusTag from 'src/components/layout/tag/StatusTag';
import {
  Table,
  Item,
  Title,
  Content,
  TopItem,
  TagDiv,
  SubTitle,
  SearchLink,
} from 'src/components/contents/detail/DetailPage';
import { DEFAULT_PAGE_SIZE, FIRST_PAGE } from 'src/components/layout/pagination/Pagination';

interface Iprops {
  data: TmarkRightsDetail;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 商標權狀態異動資料 區塊。
 */
const InfoTmarkRights: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const navigate = useNavigate();
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  const linkColor = colorType.seventh;

  /** 商標人名條件搜尋 */
  const findByName = (condition: string, value: string) => {
    const searchCondition: IReqTmarkRightsPage = {
      searchName: { keyWord: condition, value: value },
      pageNo: FIRST_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
    };
    navigate({
      pathname: process.env.PUBLIC_URL + '/trademarkRights/result',
      search: QueryString.stringify(searchCondition),
    });
  };

  return (
    <DropdownInfo
      title={`商標權狀態異動資料`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      <Table color={tableColor}>
        <Item>
          <Title>申請案號</Title>
          <Content>{data.applNo || noContent}</Content>
          <Title>圖標樣態</Title>
          <Content>{data.tmarkClassDesc || noContent}</Content>
        </Item>
        <Item>
          <Title>圖樣顏色</Title>
          <Content>{data.tmarkColorDesc || noContent}</Content>
          <Title>說明文字內容</Title>
          <Content>{data.wordDescription || noContent}</Content>
        </Item>
      </Table>
      <Table color={tableColor}>
        <Item>
          <Title>申請日</Title>
          <Content>{data.applDate || noContent}</Content>
          <Title>註冊日期</Title>
          <Content>{data.regDate || noContent}</Content>
        </Item>
        <Item>
          <Title>註冊公告日期</Title>
          <Content>{data.regNoticeDate || noContent}</Content>
          <Title>審定公告日期</Title>
          <Content>{data.examNoticeDate || noContent}</Content>
        </Item>
        <TopItem>
          <Title>目前在案狀況</Title>
          <Content>
            <TagDiv>
              <StatusTag title="異議" code={data.oppositionStatus} />
              <StatusTag title="評定" code={data.examStatus} />
              <StatusTag title="舉發" code={data.nullityActStatus} />
              <StatusTag title="撤銷廢止" code={data.applDelStatus} />
              <StatusTag title="授權" code={data.autStatus} />
              <StatusTag title="再授權" code={data.agaAutStatus} />
              <StatusTag title="展延" code={data.extendedStatus} />
              <StatusTag title="變更" code={data.amedmentStatus} />
              <StatusTag title="移轉" code={data.transferStatus} />
              <StatusTag title="提評" code={data.issueOppStatus} />
              <StatusTag title="報撤" code={data.issueDelStatus} />
              <StatusTag title="設定質權" code={data.quotaStatus} />
              <StatusTag title="禁止處分" code={data.unableUseStatus} />
            </TagDiv>
          </Content>
        </TopItem>
        <TopItem>
          <Title>撤銷原因</Title>
          <Content>{data.delReason || noContent}</Content>
        </TopItem>
      </Table>
      <SubTitle>商標權人資訊</SubTitle>
      {data.holders.map((item) => {
        return (
          <Table color={tableColor} key={item.sequence}>
            <Item>
              <Title>商標權人序號</Title>
              <Content>{item.sequence || noContent}</Content>
              <Title>商標權人中文姓名</Title>
              <Content>
                {item.chineseName ? (
                  <SearchLink
                    color={linkColor}
                    onClick={() => {
                      findByName('applnamec', item.chineseName);
                    }}
                  >
                    {item.chineseName}
                  </SearchLink>
                ) : (
                  noContent
                )}
              </Content>
            </Item>
            <Item>
              <Title>商標權人英文姓名</Title>
              <Content>
                {item.englishName ? (
                  <SearchLink
                    color={linkColor}
                    onClick={() => {
                      findByName('applnamee', item.englishName);
                    }}
                  >
                    {item.englishName}
                  </SearchLink>
                ) : (
                  noContent
                )}
              </Content>
              <Title>商標權人中文地址</Title>
              <Content>{item.address || noContent}</Content>
            </Item>
            <Item>
              <Title>商標權人國籍</Title>
              <Content>{item.chineseCountry || noContent}</Content>
            </Item>
          </Table>
        );
      })}
      {data.agents.length !== 0 && (
        <>
          <SubTitle>代理人資訊</SubTitle>
          {data.agents.map((item) => {
            return (
              <Table color={tableColor} key={item.sequence}>
                <Item>
                  <Title>代理人序號</Title>
                  <Content>{item.sequence || noContent}</Content>
                  <Title>代理人中文姓名</Title>
                  <Content>
                    {item.chineseName ? (
                      <SearchLink
                        color={linkColor}
                        onClick={() => {
                          findByName('agentname', item.chineseName);
                        }}
                      >
                        {item.chineseName}
                      </SearchLink>
                    ) : (
                      noContent
                    )}
                  </Content>
                </Item>
                <Item>
                  <Title>代理人中文地址</Title>
                  <Content>{item.address || noContent}</Content>
                </Item>
              </Table>
            );
          })}
        </>
      )}
    </DropdownInfo>
  );
};

export default InfoTmarkRights;
